var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_473_3860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3403 7.17447L13.3465 10.1806L13.3608 10.0231C13.3608 8.44371 12.0772 7.16016 10.4978 7.16016L10.3403 7.17447Z",
    fill: "url(#paint0_linear_473_3860)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4978 5.25153C13.1317 5.25153 15.2694 7.38924 15.2694 10.0232C15.2694 10.6387 15.1454 11.2256 14.9307 11.7648L17.7221 14.5562C19.1631 13.3538 20.2988 11.7982 21.0002 10.0232C19.3444 5.8337 15.2742 2.86572 10.4978 2.86572C9.16173 2.86572 7.88296 3.10429 6.69482 3.53374L8.75617 5.5903C9.29531 5.38036 9.88222 5.25153 10.4978 5.25153Z",
    fill: "url(#paint1_linear_473_3860)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.954313 2.65085L3.13018 4.82672L3.56442 5.26095C1.98977 6.49204 0.744376 8.12873 0 10.023C1.651 14.2125 5.72597 17.1805 10.4976 17.1805C11.9769 17.1805 13.3892 16.8942 14.6824 16.3741L15.088 16.7797L17.8699 19.5663L19.0866 18.3543L2.17108 1.43408L0.954313 2.65085ZM6.23178 7.92353L7.70622 9.39797C7.66327 9.60316 7.63464 9.80832 7.63464 10.023C7.63464 11.6025 8.9182 12.886 10.4976 12.886C10.7124 12.886 10.9175 12.8574 11.118 12.8144L12.5924 14.2889C11.9577 14.6038 11.2516 14.7947 10.4976 14.7947C7.86368 14.7947 5.72597 12.657 5.72597 10.023C5.72597 9.26913 5.91685 8.56292 6.23178 7.92353Z",
    fill: "url(#paint2_linear_473_3860)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_473_3860",
    x1: 10.3403,
    y1: 8.85916,
    x2: 13.3608,
    y2: 8.85916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_473_3860",
    x1: 6.69482,
    y1: 9.44164,
    x2: 21.0002,
    y2: 9.44164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_473_3860",
    x1: 0,
    y1: 11.6335,
    x2: 19.0866,
    y2: 11.6335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF2E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_473_3860"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye_close.fc54598eca41a24d25791837d92640eb.svg";
export { ForwardRef as ReactComponent };